import { render, staticRenderFns } from "./ladingDetails.vue?vue&type=template&id=0e6ffcda&scoped=true&"
import script from "./ladingDetails.vue?vue&type=script&lang=js&"
export * from "./ladingDetails.vue?vue&type=script&lang=js&"
import style0 from "./ladingDetails.vue?vue&type=style&index=0&id=0e6ffcda&lang=scss&scoped=true&"
import style1 from "./ladingDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6ffcda",
  null
  
)

export default component.exports